<template>
  <table class="table-to-export" data-sheet-name="注文書">
    <tbody>
    <tr><td></td><td></td><td></td><td>発行</td><td>{{now}}</td></tr>
    <tr><td></td><td></td><td>請求書</td><td></td><td></td></tr>
    <tr><td></td><td></td><td></td><td></td><td></td></tr>
    <tr><td>〒{{clientOffice.postcode}}</td><td></td><td></td><td></td><td>〒{{operatorOffice.postcode}}</td></tr>
    <tr><td>{{clientOffice.address}}</td><td></td><td></td><td></td><td>{{operatorOffice.address}}</td></tr>
    <tr><td>{{clientOffice.name}}</td><td></td><td></td><td></td><td>{{operatorOffice.name}}</td></tr>
    <tr><td>{{clientDetail.lastName}} {{clientDetail.firstName}}</td><td>様</td><td></td><td></td><td>{{operatorDetail.lastName}} {{operatorDetail.firstName}}</td></tr>
    <tr><td></td><td></td><td></td><td></td><td></td></tr>
    <tr><td>件名：</td><td>{{work.title}}</td><td></td><td></td><td>TEL {{operatorOffice.phoneNumber}}</td></tr>
    <tr><td></td><td></td><td></td><td></td><td>MAIL {{operatorDetail.email}}</td></tr>
    <tr><td>以下の通り請求いたします。</td><td></td><td></td><td></td><td></td><td></td></tr>
    <tr><td>合計金額（税込）</td><td>{{separatedRewardsWithTax}}</td><td></td><td></td><td></td><td></td></tr>
    <tr><td></td><td></td><td></td><td></td><td></td></tr>
    <tr><td>内訳</td><td>数量</td><td>単価</td><td>金額</td><td>備考</td></tr>
    <tr><td>作図作業</td><td>1式</td><td>¥{{separatedRewardsWithoutTax}}</td><td>¥{{separatedRewardsWithoutTax}}</td><td></td></tr>
    <tr><td>消費税（{{FEES.TAX}}％）</td><td></td><td></td><td>¥{{separatedTax}}</td><td></td></tr>
    <tr><td></td><td></td><td></td><td></td><td></td></tr>
    <tr><td>納品方法：</td><td>flewが提供するファイル送受信フォームを使用すること。</td><td></td><td></td><td></td></tr>
    <tr><td>支払い条件：</td><td>受注者のフルーアカウントへ送金（フルーの決済システムを利用）</td><td></td><td></td><td></td></tr>
    </tbody>
  </table>
</template>

<script>
  import moment from "moment";
  import FEES from "@/assets/js/constants/fees";

  export default {
    name: "BillBlock",

    props: {
      clientDetail: {
        type: Object,
        required: true
      },
      operatorDetail: {
        type: Object,
        required: true
      },
      clientOffice: {
        type: Object,
        required: true
      },
      operatorOffice: {
        type: Object,
        required: true
      },
      work: {
        type: Object,
        required: true
      },
    },

    computed: {
      now() {
        return moment().format('LL');
      },
      rewardsWithTax() {
        return this.work.rewards ? this.work.rewards : 0;
      },
      rewardsWithoutTax() {
        return Math.ceil(this.work.rewards / (1 + FEES.TAX * 0.01))
      },
      tax() {
        return this.work.rewards ? this.work.rewards - this.rewardsWithoutTax : 0;
      },
      separatedRewardsWithTax() {
        return this.rewardsWithTax.toLocaleString();
      },
      separatedRewardsWithoutTax() {
        return this.rewardsWithoutTax.toLocaleString();
      },
      separatedTax() {
        return this.tax.toLocaleString();
      },
      deadline() {
        return !this.work.deadline ? '' : moment.unix(this.work.deadline.seconds).format('YYYY/MM/DD HH:mm');
      },
    },
    beforeCreate() {
      Object.assign(this, {FEES});
    },

  }
</script>

<style scoped>

</style>